export function getCurrentRouteQueryParams(keyName: string): string | null {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(keyName);
}
